import React, { useEffect, useState } from "react";
import "../../App.css";
import { apiPostAuth } from "../../utils/api";
import { useNavigate } from "react-router-dom";

export default function AccountSettings() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [userInfo, setUserInfo] = useState({
    email: "",
    full_name: "",
    company_name: "",
    country: "",
  });

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const response = await apiPostAuth("account/get_account_info.php");
        if (response.result === 1) {
          setUserInfo({
            email: response.data.email,
            full_name: response.data.full_name,
            company_name: response.data.company_name,
            country: response.data.country,
          });
        } else {
          alert(response.message || "Failed to load account information.");
        }
      } catch (error) {
        alert("Unable to load account information.");
      } finally {
        setLoading(false);
      }
    };

    fetchUserInfo();
  }, []);

  const handleChangePassword = () => {
    navigate("/dashboard/account-settings/change-password");
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <div className="loading-spinner"></div>
        <p>Loading account settings...</p>
      </div>
    );
  }

  return (
    <div style={{ padding: "20px" }}>
      <h1 style={{ fontSize: "1.8rem", marginBottom: "20px", color: "#1f2937" }}>
        Account Settings
      </h1>

      {/* Information Section */}
      <section style={sectionStyle}>
        <h2 style={sectionTitleStyle}>Account Information</h2>
        <div style={infoRowStyle}>
          <strong>Email:</strong>
          <span>{userInfo.email}</span>
        </div>
        <div style={infoRowStyle}>
          <strong>Full Name:</strong>
          <span>{userInfo.full_name}</span>
        </div>
        <div style={infoRowStyle}>
          <strong>Company Name:</strong>
          <span>{userInfo.company_name || "-"}</span>
        </div>
        <div style={infoRowStyle}>
          <strong>Country:</strong>
          <span>{userInfo.country || "-"}</span>
        </div>
      </section>

      {/* Security Section */}
      <section style={sectionStyle}>
        <h2 style={sectionTitleStyle}>Security</h2>
        <p style={{ fontSize: "0.95rem", color: "#4b5563", marginBottom: "10px" }}>
          For your security, we recommend updating your password regularly.
        </p>
        <button onClick={handleChangePassword} className="primary-button">
          Change Password
        </button>
      </section>
    </div>
  );
}

/* --- Styles --- */
const sectionStyle = {
  backgroundColor: "#fff",
  padding: "20px",
  borderRadius: "8px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
  marginBottom: "20px",
};

const sectionTitleStyle = {
  fontSize: "1.2rem",
  marginBottom: "15px",
  color: "#1f2937",
  borderBottom: "1px solid #e5e7eb",
  paddingBottom: "5px",
};

const infoRowStyle = {
  display: "flex",
  justifyContent: "space-between",
  padding: "8px 0",
  fontSize: "1rem",
  color: "#374151",
};
